export enum ProgramOrganizationType {
  Program = 'PROGRAM',
  Organization = 'ORGANIZATION',
}
